"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CollapseAllVisibility;
(function (CollapseAllVisibility) {
    CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
    CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
})(CollapseAllVisibility = exports.CollapseAllVisibility || (exports.CollapseAllVisibility = {}));
//# sourceMappingURL=GroupedList.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/GroupedList/GroupedList.types.js
// module id = 793
// module chunks = 0